import dicGrid from './dicGrid';

var Plugin = {
  install: function install(Vue) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (Object.keys(option).length) {
      var props = dicGrid.mixins[0].props;
      if (typeof option.title === 'string') props.title.default = option.title;
      if (typeof option.appMark === 'string') props.appMark.default = option.appMark;
      if (typeof option.language === 'string') props.language.default = option.language;
      if (typeof option.placeholder === 'string') props.placeholder.default = option.placeholder;
      if (typeof option.pageSize === 'number') props.pageSize.default = option.pageSize;
      if (typeof option.rtl === 'boolean') props.rtl.default = option.rtl;

      if (option.dataLoad && typeof option.dataLoad === 'function') {
        dicGrid.extends = {
          methods: {
            dataLoad: option.dataLoad
          }
        };
      }
    }
    Vue.component(dicGrid.name, dicGrid);
  }
};
export { dicGrid };
export default Plugin;


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/index.js
// module id = 3
// module chunks = 0